import React, { useEffect, useState } from "react";
import { AppContext } from "../../App";
import DateSelector from "../../common/DateSelector";
import Loader from "../../common/Loader";
import { useFetchCalendarData } from '../../data/fetchCalendarData';
import { LiveContext } from "../Live";
import LiveSporstNav from "../live-suite/LiveSportsNav";
import { isOverlaySection } from '../../utils/sport-effects';
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';

function LiveCalendar(props) {
    const appContext = React.useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const conf = getConfiguration();

    const [state, setState] = useState({
        showLoader: true,
        data: null,
        dateFetch: '',
        date: null,
        sport: null,
        showSportsMenu: false,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setShowLoader(showLoader) {
            this.update({showLoader});
        },
        setData(data) {
            let date = null;
            if (this.dateFetch === '') {
                date = data.dates[0];
            } else {
                date = data.dates.find(d => { return d.DBDate === this.dateFetch });
            }
            this.update({showLoader: false, data, date: date.DBDate, sport: date.sports[0], showSportsMenu: false});
        },
        setDate(dateFetch) {
            if (dateFetch !== this.date) {
                this.update({dateFetch});
            }
        },
        setSport(sport) {
            this.update({sport});
        },
        toggleSportsMenu() {
            this.update({showSportsMenu: !this.showSportsMenu});
        }
    });

    function changeDate(date) {
        state.setDate(date, null);
    }

    function changeSport(sportId) {
        state.setSport(sportId);
    }

    function toggleSportsMenu() {
        state.toggleSportsMenu();
    }

    function handleClickSportsNav(sportId){
        liveContext.openLiveSuite(sportId)
    }

    const [request] = useFetchCalendarData(state.dateFetch);

    useEffect(() => {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function() {
                state.setShowLoader(true);
            }, conf.lspt);
        } else if (!request.isError) {
            clearTimeout(false);
            state.setData(request.data);
        } else {
            state.setShowLoader(true);
        }
        
        return () => {
            clearInterval(timeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request]);

    if (state.showLoader) {
        return <Loader error={request.isError} hide={appContext.showBetslip} />;
    }

    const currentDate = state.data.dateById[state.date];
    const hideWrapper = isOverlaySection(appContext,props.section);
    
    return (
        <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
            <div id="main-container" className="main-content">
                <LiveSporstNav sports={liveContext.sports}  changeSport={handleClickSportsNav} />
                <DateSelector dates={state.data.dates} date={state.date} changeDate={changeDate} />
                <nav id="nav-classe-scommessa" className="small" onClick={toggleSportsMenu}>
                    <span className="nav-section-title">{state.data.dateById[state.date].date}</span>
                    <div id="gruppo-scommessa-selector" className="bet-type-selector expandable nav-section-title">
                        <div className="text-small uppercase push-left">{state.sport.desc}</div>
                        {state.showSportsMenu &&
                            <div id="popup-calendar-sports" className="popup">
                                <div className="popup-content">
                                    {currentDate.sports.map(sport => {
                                        function handleClick() {
                                            changeSport(sport);
                                        }
                                        return <div key={sport.id} className={"event-desc text-small" + classIf(state.sport.id === sport.id, 'selected')} onClick={handleClick}>{sport.desc} ({sport.events.length})</div>
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                </nav>
                {state.sport.events.map(match => {
                    return (
                        <div key={match.id} className="calendar-row">
                            <div className="calendar-row-time">{match.time}</div>
                            <div className="calendar-row-match">
                                <span>{match.team1}</span>
                                <span>{match.team2}</span>
                            </div>
                            <div className="calendar-row-category">{match.competition}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default LiveCalendar;